import Questionnaire from "../../../../../../libs/api/services/Questionnaire";
import DatePickerComponent from "../widgets/DatePickerComponent";
import DisplayTextComponent from "../widgets/DisplayTextComponent";
import DynamicComponentsTable from "../widgets/DynamicComponentsTable";
import FacilitiesComponent from "../widgets/FacilitiesComponent";
import ICD10Component from "../widgets/ICD10Component";
import MultiSelectionComponent from "../widgets/MultiSelectionComponent";
import NewComponentWidget from "../widgets/NewComponentWidget";
import PMBComponent from "../widgets/PMBComponent";
import SingleSelectionComponent from "../widgets/SingleSelectionComponent";
import TermsAndConditionsComponent from "../widgets/TermsAndConditionsComponent";
import TextBoxComponent from "../widgets/TextBoxComponent";
import TextInputComponent from "../widgets/TextInputComponent";
import ComponentContainer from "./ComponentContainer";
import GridContainer from "./GridContainer";

export default function SectionContainer({
  handleNext,
  handleDone,
  handleChangeLayout,
  handleUserInput,
  handleUserInputComplete,
  layout,
  currentStep,
  sections,
  validationErrors,
  onEditComponent,
  questionnaireData,
  onAddComponent,
  platform = 'questionnaire', // Default to 'questionnaire' if not provided
}) {
  const handleAddComponent = (section) => {
    // Logic to add a new component to the section
    console.log("Add component to section:", section);
    // This could open a modal or redirect to a component creation page
    Questionnaire.AddComponentToSection(section.id, {
      question: "",
      layout: {
        w: 12,
        h: 10
      }
      //   componentType: { type: "New" },
    })
      .then(() => {
        if (onAddComponent) onAddComponent(section.id);
        console.log("Component added successfully");
      })
      .catch((err) => {
        console.error("Error adding component:", err);
      });
  };

  const sortComponents = (components, layoutType) =>
    [...(components || [])].sort((a, b) => {
      const aOrder = Number.isFinite(Number(a?.order)) ? Number(a.order) : null;
      const bOrder = Number.isFinite(Number(b?.order)) ? Number(b.order) : null;

      const ay = Number.isFinite(Number(a?.layout?.y)) ? Number(a.layout.y) : 0;
      const by = Number.isFinite(Number(b?.layout?.y)) ? Number(b.layout.y) : 0;
      const ax = Number.isFinite(Number(a?.layout?.x)) ? Number(a.layout.x) : 0;
      const bx = Number.isFinite(Number(b?.layout?.x)) ? Number(b.layout.x) : 0;

      const isFormLikeLayout = layoutType !== "Wizard Layout";
      if (isFormLikeLayout) {
        if (ay !== by) {
          return ay - by;
        }
        if (ax !== bx) {
          return ax - bx;
        }
      }

      if (aOrder !== null && bOrder !== null && aOrder !== bOrder) {
        return aOrder - bOrder;
      }

      if (ay !== by) {
        return ay - by;
      }
      return ax - bx;
    });

  return sections.length === 0 ? (
    <div>No sections available in this questionnaire.</div>
  ) : (
    sections.map((section, index) => {
      const orderedComponents = sortComponents(section.components, layout);
      return (
        <form
          key={section.id}
          onSubmit={(e) => {
            e.preventDefault();
            if (currentStep === sections.length) handleDone();
            else handleNext();
          }}
          className={`section flex-grow-1 px-2 ${platform === 'questionnaire' ? 'bg-primary-container' : ''} ${(layout === "Wizard Layout" && currentStep === (index + 1)) ||
            layout === "Form Layout"
            ? "d-flex flex-column"
            : "d-none"
            }`}
        >
          <h2 className="text-center p-2">{section.title}</h2>
          <GridContainer
            handleChangeLayout={(layout) => handleChangeLayout(section, layout)}
            components={orderedComponents}
            access={[...section.accessTypes]}
          >
            {orderedComponents
              .map((component, compIndex) => {
                return (
                  <ComponentContainer
                    key={component.componentId}
                    component={component}
                    error={
                      validationErrors && validationErrors[component.componentId]
                    }
                    onEdit={onEditComponent}
                    access={[...section.accessTypes]}
                  >
                    {{
                      "Display Text": (
                        <DisplayTextComponent
                          onUserInput={(value) =>
                            handleUserInput(component.componentId, value)
                          }
                          onUserInputComplete={(_) =>
                            handleUserInputComplete(component.componentId)
                          }
                          defaultValues={
                            (questionnaireData?.[component.componentId]
                              && typeof questionnaireData?.[component.componentId].value === 'string'
                              && (questionnaireData?.[component.componentId].value.startsWith('[') || questionnaireData?.[component.componentId].value.startsWith('{'))
                              && JSON.parse(questionnaireData?.[component.componentId].value)
                            ) ||
                            undefined
                          }
                          component={component}
                        />
                      ),
                      "Single Selection": (
                        <SingleSelectionComponent
                          onUserInput={(value) =>
                            handleUserInput(component.componentId, value)
                          }
                          onUserInputComplete={(_) =>
                            handleUserInputComplete(component.componentId)
                          }
                          defaultValues={
                            (questionnaireData?.[component.componentId] &&
                              questionnaireData?.[component.componentId].value) ||
                            undefined
                          }
                          component={component}
                        />
                      ),
                      Facilities: (
                        <FacilitiesComponent
                          onUserInput={(value) =>
                            handleUserInput(component.componentId, JSON.stringify(value))
                          }
                          onUserInputComplete={(_) =>
                            handleUserInputComplete(component.componentId)
                          }
                          defaultValues={
                            ((questionnaireData?.[component.componentId]
                              && typeof questionnaireData?.[component.componentId].value === 'string'
                              && (questionnaireData?.[component.componentId].value.startsWith('[') || questionnaireData?.[component.componentId].value.startsWith('{'))
                              && JSON.parse(questionnaireData?.[component.componentId].value))
                              ||
                              (questionnaireData?.[component.componentId]
                                && typeof questionnaireData?.[component.componentId] === 'object'
                                && Object.keys(questionnaireData?.[component.componentId]).includes('value')
                                && questionnaireData?.[component.componentId].value))
                            ||
                            undefined
                          }
                          test={questionnaireData?.[component.componentId]}
                          component={component}
                        />
                      ),
                      "Get Input text": (
                        <TextInputComponent
                          onUserInput={(value) =>
                            handleUserInput(component.componentId, value)
                          }
                          onUserInputComplete={(_) =>
                            handleUserInputComplete(component.componentId)
                          }
                          defaultValues={
                            (questionnaireData?.[component.componentId] &&
                              questionnaireData?.[component.componentId].value) ||
                            undefined
                          }
                          component={component}
                          compIndex={compIndex}
                        />
                      ),
                      "Date Picker": (
                        <DatePickerComponent
                          onUserInput={(value) =>
                            handleUserInput(component.componentId, value)
                          }
                          onUserInputComplete={(_) =>
                            handleUserInputComplete(component.componentId)
                          }
                          defaultValues={
                            (questionnaireData?.[component.componentId] &&
                              questionnaireData?.[component.componentId].value) ||
                            undefined
                          }
                          component={component}
                        />
                      ),
                      "ICD10": (
                        <ICD10Component
                          onUserInput={(value) =>
                            handleUserInput(component.componentId, value)
                          }
                          onUserInputComplete={(_) =>
                            handleUserInputComplete(component.componentId)
                          }
                          defaultValues={
                            (questionnaireData?.[component.componentId] &&
                              questionnaireData?.[component.componentId].value) ||
                            undefined
                          }
                          component={component}
                        />
                      ),
                      "PMB": (
                        <PMBComponent
                          onUserInput={(value) =>
                            handleUserInput(component.componentId, value)
                          }
                          onUserInputComplete={(_) =>
                            handleUserInputComplete(component.componentId)
                          }
                          defaultValues={
                            (questionnaireData?.[component.componentId] &&
                              questionnaireData?.[component.componentId].value) ||
                            undefined
                          }
                          component={component}
                        />
                      ),
                      "Multiple Selection": (
                        <MultiSelectionComponent
                          onUserInput={(value) =>
                            handleUserInput(component.componentId, JSON.stringify(value))
                          }
                          onUserInputComplete={(_) =>
                            handleUserInputComplete(component.componentId)
                          }
                          defaultValues={
                            (questionnaireData?.[component.componentId]
                              && typeof questionnaireData?.[component.componentId].value === 'string'
                              && (questionnaireData?.[component.componentId].value.startsWith('[') || questionnaireData?.[component.componentId].value.startsWith('{'))
                              && JSON.parse(questionnaireData?.[component.componentId].value)
                            ) ||
                            undefined
                          }
                          component={component}
                        />
                      ),
                      "Dynamic Component Table": (
                        <DynamicComponentsTable
                          onUserInput={(value) =>
                            handleUserInput(component.componentId, JSON.stringify(value))
                          }
                          onUserInputComplete={(_) =>
                            handleUserInputComplete(component.componentId)
                          }
                          defaultValues={
                            (questionnaireData?.[component.componentId]
                              && typeof questionnaireData?.[component.componentId].value === 'string'
                              && (questionnaireData?.[component.componentId].value.startsWith('[') || questionnaireData?.[component.componentId].value.startsWith('{'))
                              && JSON.parse(questionnaireData?.[component.componentId].value)
                            ) ||
                            undefined
                          }
                          component={component}
                        />
                      ),
                      "Terms And Conditions": (
                        <TermsAndConditionsComponent
                          onUserInput={(value) =>
                            handleUserInput(component.componentId, JSON.stringify(value))
                          }
                          onUserInputComplete={(_) =>
                            handleUserInputComplete(component.componentId)
                          }
                          defaultValues={
                            (questionnaireData?.[component.componentId]
                              && typeof questionnaireData?.[component.componentId].value === 'string'
                              && (questionnaireData?.[component.componentId].value.startsWith('[') || questionnaireData?.[component.componentId].value.startsWith('{'))
                              && JSON.parse(questionnaireData?.[component.componentId].value)
                            ) ||
                            undefined
                          }
                          component={component}
                        />
                      ),
                      "Text Box": (
                        <TextBoxComponent
                          onUserInput={(value) =>
                            handleUserInput(component.componentId, value)
                          }
                          onUserInputComplete={(_) =>
                            handleUserInputComplete(component.componentId)
                          }
                          defaultValues={
                            (questionnaireData?.[component.componentId] &&
                              questionnaireData?.[component.componentId].value) ||
                            undefined
                          }
                          component={component}
                          compIndex={compIndex}
                        />
                      ),
                      // Add more component types as needed
                      // Example for a new component type:
                      // "New Component Type": () => <NewComponentTypeComponent ... />,
                      New: (
                        <NewComponentWidget
                          onUserInput={(value) =>
                            handleUserInput(component.componentId, value)
                          }
                          onUserInputComplete={(_) =>
                            handleUserInputComplete(component.componentId)
                          }
                          defaultValues={
                            (questionnaireData?.[component.componentId] &&
                              questionnaireData?.[component.componentId].value) ||
                            undefined
                          }
                          component={component}
                        />
                      ),
                    }[component.componentType] || (
                        <div>Unknown Component Type ({component.componentType})</div>
                      )}
                  </ComponentContainer>
                )
              }
              )}
          </GridContainer>
          {section.accessTypes.includes("Admin") && (
            <button onClick={() => handleAddComponent(section)} className="m-2">
              Add Component
            </button>
          )}
        </form>
      )
    })
  );
}
